import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectAllRoles = createSelector(
  [
    (state: RootState) => state.user.roles,
    (state: RootState) => state.user.accessRoles
  ],
  (roles: string[], accessRoles: string[]) => roles.concat(accessRoles)
)

export default selectAllRoles
